import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BackButton from '../subcomponents/BackButton';
import ContentLoader from '../subcomponents/ContentLoader';
import PageLayout from '../subcomponents/PageLayout';
import ActivityCard from './ActivityCard';
import { fetchActivity } from './activitySlice';

export default function ActivityPage() {
    const dispatch = useDispatch();

    const { id } = useParams();
    const { activity } = useSelector((state) => state.activity);

    useEffect(() => {
        dispatch(fetchActivity(id));
    }, [dispatch, id]);

    return (
        <PageLayout
            content={
                <ContentLoader
                    successCondition={activity.status === "success"}
                    errorCondition={activity.status === "failed"}
                    content={
                        <ActivityCard activity={activity.data} />
                    }
                />
            } contentRight={
                <BackButton desktop />
            }
            bottomBar
            disableContentBackground
        />
    );
}
